<fui-rows [label]="'Plan'">
    <fui-content-layout-header-control slot="after">
        @if (!editing && model.canEdit() && !cancelling) {
            <fui-link-button [title]="'edit'"
                             (click)="edit()"></fui-link-button>
        }
    </fui-content-layout-header-control>
    @if (data && model && model.data) {
        @if (model.data.subscription) {
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <fui-text-control [value]="model.data.subscription.status"
                                              [label]="'fhm.venue-plan.status'"
                                              [disabled]="true">
                            </fui-text-control>
                            @if (model.data.subscription.status === 'CANCELLED') {
                                <fui-text-control [value]="model.data.subscription.cancelledDateFormatted"
                                                  [label]="'fhm.venue-plan.cancelledDate'"
                                                  [disabled]="true">
                                </fui-text-control>
                            }
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column>
                        <fui-tandem-field>
                            <fui-text-control [value]="model.data.subscription.currentTermStartDateFormatted"
                                              [label]="'fhm.venue-plan.currentTermStartDate'"
                                              [disabled]="true">
                            </fui-text-control>
                            <fui-text-control [value]="model.data.subscription.currentTermEndDateFormatted"
                                              [label]="'fhm.venue-plan.currentTermEndDate'"
                                              [disabled]="true">
                            </fui-text-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            @if (UserData.isAdmin(loggedUser)) {
                <fui-row>
                    <fui-two-columns>
                        <fui-column>
                            <fui-tandem-field>
                                @if (model.data.subscription.status === 'ACTIVE' && !cancelling && !editing && !changingCancellationReason) {
                                    <fhm-provision-button [title]="'Cancel Subscription'"
                                                          (clicked)="cancelling = true"></fhm-provision-button>
                                }
                                @if (model.data.subscription.status === 'CANCELLED' && !editing && !changingCancellationReason) {
                                    <fhm-provision-button [title]="'Resume Subscription'"
                                                          (clicked)="resumeCurrentSubscription()"></fhm-provision-button>
                                }
                                @if (model.data.subscription.status === 'CANCELLED' && !editing && !changingCancellationReason) {
                                    <fhm-provision-button [title]="'Churn Subscription'"
                                                          (clicked)="churnCurrentSubscription()"></fhm-provision-button>
                                }
                            </fui-tandem-field>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
                @if ((model.data.subscription.status === 'CANCELLED' || model.data.subscription.status === 'CHURNED') && !changingCancellationReason) {
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <fui-tandem-field>
                                    <fui-text-control [value]="model.data.subscription.cancellationReason"
                                                      [label]="'Cancellation Reason'"
                                                      [disabled]="true">
                                    </fui-text-control>
                                </fui-tandem-field>
                                @if (!editing) {
                                    <fui-link-button [title]="'change reason'" (click)="changingCancellationReason = true"></fui-link-button>
                                }

                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                }

                @if (cancelling) {
                    <fui-row [label]="'Provide a Cancellation Reason'">
                        <fui-two-columns>
                            <fui-column>
                                <fhm-cancel-reasons-select-control
                                    [(value)]="model.data.subscription.cancellationReason">
                                </fhm-cancel-reasons-select-control>
                                <fhm-action-buttons>
                                    <fhm-remove-button [title]="'fhm.common.button.cancel'"
                                                       (clicked)="cancelling = false"></fhm-remove-button>
                                    <fhm-provision-button
                                        [disabled]="!model.data.subscription.cancellationReason"
                                        [title]="'Save Cancellation'"
                                        (clicked)="cancelCurrentSubscription()"></fhm-provision-button>
                                </fhm-action-buttons>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                }

                @if (changingCancellationReason) {
                    <fui-row [label]="'Change Cancellation Reason'">
                        <fui-two-columns>
                            <fui-column>
                                <fhm-cancel-reasons-select-control
                                    [(value)]="model.data.subscription.cancellationReason">
                                </fhm-cancel-reasons-select-control>
                                <fhm-action-buttons>
                                    <fhm-remove-button [title]="'fhm.common.button.cancel'"
                                                       (clicked)="cancelChangeCancellationReason()"></fhm-remove-button>
                                    <fhm-provision-button
                                        [disabled]="!model.data.subscription.cancellationReason"
                                        [title]="'Save Reason'"
                                        (clicked)="changeCancellationReason()"></fhm-provision-button>
                                </fhm-action-buttons>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                }

            }
        }
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <fhm-venue-plan-select-control
                        [(value)]="data.planName"
                        [disabled]="!editing && !model.newVenue"
                        (valueChange)="changePlanSelection()"
                        [label]="'fhm.venue-plan.name'">
                    </fhm-venue-plan-select-control>
                </fui-column>
                @if (model.data.subscription && model.data.subscription.currentBillingPeriodStartFormatted) {
                    <fui-column
                    >
                        <fui-tandem-field>
                            <fui-text-control [value]="model.data.subscription.currentBillingPeriodStartFormatted"
                                              [label]="'fhm.venue-plan.currentBillingPeriodStart'"
                                              [disabled]="true">
                            </fui-text-control>
                            <fui-text-control [value]="model.data.subscription.currentBillingPeriodEndFormatted"
                                              [label]="'fhm.venue-plan.currentBillingPeriodEnd'"
                                              [disabled]="true">
                            </fui-text-control>
                        </fui-tandem-field>
                    </fui-column>
                }
                @if (!model.data.subscription) {
                    <fui-column>
                        <ng-container [formGroup]="formGroupPlan">
                            <fui-date-control [label]="'fhm.venue-plan.initialTermStartDate'"
                                              formControlName="initialTermStartDate"
                                              [control]="formGroupPlan.get('initialTermStartDate')"
                                              [(ngModel)]="initialTermStartDate"
                                              [disabled]="!editing"
                                              (valueChange)="changeInitialTermDate($event)">
                            </fui-date-control>
                        </ng-container>
                    </fui-column>
                }
            </fui-two-columns>
        </fui-row>
        @if (custom) {
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-numeric-control [label]="'fhm.venue-plan.rate'"
                                             [placeholder]="' '"
                                             [disabled]="!editing && !model.newVenue"
                                             [decimals]="2"
                                             [ngModelOptions]="{standalone: true}"
                                             [(ngModel)]="data.feePercentage"></fui-numeric-control>
                    </fui-column>
                    <fui-column>
                        <fui-numeric-control [label]="'fhm.venue-plan.months'"
                                             [placeholder]="' '"
                                             [disabled]="!editing && !model.newVenue"
                                             [decimals]="0"
                                             [ngModelOptions]="{standalone: true}"
                                             [(ngModel)]="data.months"></fui-numeric-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        }
        @if (custom) {
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fhm-subscription-type-select-control
                            [(value)]="data.venueSubscriptionType"
                            [disabled]="!editing && !model.newVenue">
                        </fhm-subscription-type-select-control>
                        @if (data.venueSubscriptionType === 'MIN_AMOUNT_SALES') {
                            <fui-numeric-control [label]="'fhm.venue-plan.minWeekly'"
                                                 [placeholder]="'Standard minimums rules'"
                                                 [disabled]="!editing && !model.newVenue"
                                                 [decimals]="2"
                                                 [ngModelOptions]="{standalone: true}"
                                                 [(ngModel)]="data.minWeeklySales"></fui-numeric-control>
                        }
                        @if (data.venueSubscriptionType === 'FIXED_MONTHLY_FEE') {
                            <fui-numeric-control [label]="'fhm.venue-plan.fixedMonthly'"
                                                 [placeholder]="'Standard minimums rules'"
                                                 [disabled]="!editing && !model.newVenue"
                                                 [decimals]="2"
                                                 [ngModelOptions]="{standalone: true}"
                                                 [(ngModel)]="data.fixedMonthlyFee"></fui-numeric-control>
                        }
                    </fui-column>
                    <fui-column>
                        <fui-textarea-control [label]="'fhm.venue-plan.customTerms'"
                                              [placeholder]="' '"
                                              [disabled]="!editing && !model.newVenue"
                                              [ngModelOptions]="{standalone: true}"
                                              [(ngModel)]="data.customTerms"></fui-textarea-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        }
        <!-- Tyro Plan -->
        @if (tyro) {
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-numeric-control [label]="'fhm.venue-plan.chewzieFee'"
                                             [placeholder]="' '"
                                             [disabled]="!editing && !model.newVenue"
                                             [decimals]="2"
                                             [ngModelOptions]="{standalone: true}"
                                             [(ngModel)]="data.feePercentage"></fui-numeric-control>
                    </fui-column>
                    <fui-column>
                        <fui-numeric-control [label]="'fhm.venue-plan.months'"
                                             [placeholder]="' '"
                                             [disabled]="!editing && !model.newVenue"
                                             [decimals]="0"
                                             [ngModelOptions]="{standalone: true}"
                                             [(ngModel)]="data.months"></fui-numeric-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-numeric-control [label]="'fhm.venue-plan.tyroFeePercentage'"
                                             [placeholder]="' '"
                                             [disabled]="!editing && !model.newVenue"
                                             [decimals]="2"
                                             [ngModelOptions]="{standalone: true}"
                                             [(ngModel)]="data.stripeDomesticFeePercentage"></fui-numeric-control>
                    </fui-column>
                    <fui-column>
                        <fui-numeric-control [label]="'fhm.venue-plan.tyroFeeFixed'"
                                             [placeholder]="' '"
                                             [disabled]="!editing && !model.newVenue"
                                             [decimals]="3"
                                             [ngModelOptions]="{standalone: true}"
                                             [(ngModel)]="data.stripeDomesticFeeFixed"></fui-numeric-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fhm-subscription-type-select-control
                            [(value)]="data.venueSubscriptionType"
                            [disabled]="!editing && !model.newVenue">
                        </fhm-subscription-type-select-control>
                        @if (data.venueSubscriptionType === 'MIN_AMOUNT_SALES') {
                            <fui-numeric-control [label]="'fhm.venue-plan.minWeekly'"
                                                 [placeholder]="'Standard minimums rules'"
                                                 [disabled]="!editing && !model.newVenue"
                                                 [decimals]="2"
                                                 [ngModelOptions]="{standalone: true}"
                                                 [(ngModel)]="data.minWeeklySales"></fui-numeric-control>
                        }
                        @if (data.venueSubscriptionType === 'FIXED_MONTHLY_FEE') {
                            <fui-numeric-control [label]="'fhm.venue-plan.fixedMonthly'"
                                                 [placeholder]="'Standard minimums rules'"
                                                 [disabled]="!editing && !model.newVenue"
                                                 [decimals]="2"
                                                 [ngModelOptions]="{standalone: true}"
                                                 [(ngModel)]="data.fixedMonthlyFee"></fui-numeric-control>
                        }
                    </fui-column>
                    <fui-column>
                        <fui-textarea-control [label]="'fhm.venue-plan.customTerms'"
                                              [placeholder]="' '"
                                              [disabled]="!editing && !model.newVenue"
                                              [ngModelOptions]="{standalone: true}"
                                              [(ngModel)]="data.customTerms"></fui-textarea-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        }
        <!-- Stripe Fees -->
        @if (custom && UserData.isAdmin(loggedUser)) {
            <fui-row>
                <fui-column>
                    <fui-checkbox-control [label]="'fhm.venue-plan.overrideStripeFees'"
                                          [placeholder]="' '"
                                          [disabled]="!editing && !model.newVenue"
                                          [ngModelOptions]="{standalone: true}"
                                          [(ngModel)]="data.overrideStripeFees"
                    ></fui-checkbox-control>
                </fui-column>
            </fui-row>
            @if (data.overrideStripeFees) {
                <fui-row>
                    <fui-two-columns>
                        <fui-column>
                            <fui-numeric-control [label]="'fhm.venue-plan.stripeDomesticFeePercentage'"
                                                 [placeholder]="' '"
                                                 [disabled]="!editing && !model.newVenue"
                                                 [decimals]="2"
                                                 [ngModelOptions]="{standalone: true}"
                                                 [(ngModel)]="data.stripeDomesticFeePercentage"></fui-numeric-control>
                        </fui-column>
                        <fui-column>
                            <fui-numeric-control [label]="'fhm.venue-plan.stripeDomesticFeeFixed'"
                                                 [placeholder]="' '"
                                                 [disabled]="!editing && !model.newVenue"
                                                 [decimals]="2"
                                                 [ngModelOptions]="{standalone: true}"
                                                 [(ngModel)]="data.stripeDomesticFeeFixed"></fui-numeric-control>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
                <fui-row>
                    <fui-two-columns>
                        <fui-column>
                            <fui-numeric-control [label]="'fhm.venue-plan.stripeInternationalFeePercentage'"
                                                 [placeholder]="' '"
                                                 [disabled]="!editing && !model.newVenue"
                                                 [decimals]="2"
                                                 [ngModelOptions]="{standalone: true}"
                                                 [(ngModel)]="data.stripeInternationalFeePercentage"></fui-numeric-control>
                        </fui-column>
                        <fui-column>
                            <fui-numeric-control [label]="'fhm.venue-plan.stripeInternationalFeeFixed'"
                                                 [placeholder]="' '"
                                                 [disabled]="!editing && !model.newVenue"
                                                 [decimals]="2"
                                                 [ngModelOptions]="{standalone: true}"
                                                 [(ngModel)]="data.stripeInternationalFeeFixed"></fui-numeric-control>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
            }
        }
        <!-- -->
            <!-- Tiered Pricing -->
        @if (custom) {
            <fui-row>
                <fui-column>
                    <fui-checkbox-control [label]="'Tiered Pricing'"
                                          [placeholder]="' '"
                                          [disabled]="!editing && !model.newVenue"
                                          [ngModelOptions]="{standalone: true}"
                                          (valueChange)="changeUseTieredPricing($event)"
                                          [(ngModel)]="useTieredPricing"
                    ></fui-checkbox-control>
                </fui-column>
            </fui-row>
            @if (custom && useTieredPricing) {
                <fui-row>
                    <fui-two-columns>
                        <fui-column>
                            <fui-tandem-field>
                                <fui-checkbox-control [label]="'Base Tiers on Group Gross Sales'"
                                                      [placeholder]="' '"
                                                      [disabled]="!editing && !model.newVenue"
                                                      [ngModelOptions]="{standalone: true}"
                                                      [(ngModel)]="data.useGroupSalesForTieredPricing"
                                ></fui-checkbox-control>
                                @if (data.useGroupSalesForTieredPricing) {
                                    <fui-text-control [label]="'Group Name'"
                                                      [placeholder]="' '"
                                                      [disabled]="(!editing && !model.newVenue)"
                                                      [ngModelOptions]="{standalone: true}"
                                                      [(ngModel)]="data.groupName"></fui-text-control>
                                }
                            </fui-tandem-field>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
            }
        }
        @if (custom && useTieredPricing && (!data.overrideStripeFees || !UserData.isAdmin(loggedUser))) {
            @for (tier of data.pricingTiers; track tier; let i = $index) {
                <fui-row>
                    <fui-rows [label]="'Tier ' + (i + 1) + tierLabel(i)">
                        <fui-row>
                            <fui-two-columns>
                                <fui-column>
                                    <fui-numeric-control
                                        [label]="(data.useGroupSalesForTieredPricing ? 'Group ' : '') + 'Gross Sales per month'"
                                        [placeholder]="' '"
                                        [disabled]="(!editing && !model.newVenue) || i === 0"
                                        [decimals]="2"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="tier.tierMonthlyAmount"></fui-numeric-control>
                                </fui-column>
                                <fui-column>
                                    <fui-numeric-control [label]="'fhm.venue-plan.rate'"
                                                         [placeholder]="'default'"
                                                         [disabled]="!editing && !model.newVenue"
                                                         [decimals]="2"
                                                         [ngModelOptions]="{standalone: true}"
                                                         [(ngModel)]="tier.feePercentage"></fui-numeric-control>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                    </fui-rows>
                </fui-row>
            }
            @if (editing || model.newVenue) {
                <fui-row>
                    <fui-column>
                        <fhm-action-buttons>
                            <fui-link-button [title]="'+ add tier'" (click)="addTier()"></fui-link-button>
                            @if (data.pricingTiers.length > 0) {
                                <fui-link-button [title]="'- remove tier'" (click)="removeTier()"></fui-link-button>
                            }
                        </fhm-action-buttons>
                    </fui-column>
                </fui-row>
            }
        }
        @if (custom && useTieredPricing && data.overrideStripeFees && UserData.isAdmin(loggedUser)) {
            @for (tier of data.pricingTiers; track tier; let i = $index) {
                <fui-row>
                    <fui-rows [label]="'Tier ' + (i + 1) + tierLabel(i)">
                        <fui-row>
                            <fui-two-columns>
                                <fui-column>
                                    <fui-numeric-control
                                        [label]="(data.useGroupSalesForTieredPricing ? 'Group ' : '') + 'Gross Sales per month'"
                                        [placeholder]="' '"
                                        [disabled]="(!editing && !model.newVenue) || i === 0"
                                        [decimals]="2"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="tier.tierMonthlyAmount"></fui-numeric-control>
                                </fui-column>
                                <fui-column>
                                    <fui-numeric-control [label]="'fhm.venue-plan.rate'"
                                                         [placeholder]="'default'"
                                                         [disabled]="!editing && !model.newVenue"
                                                         [decimals]="2"
                                                         [ngModelOptions]="{standalone: true}"
                                                         [(ngModel)]="tier.feePercentage"></fui-numeric-control>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                        <fui-row>
                            <fui-two-columns>
                                <fui-column>
                                    <fui-numeric-control [label]="'fhm.venue-plan.stripeDomesticFeePercentage'"
                                                         [placeholder]="'default'"
                                                         [disabled]="!editing && !model.newVenue"
                                                         [decimals]="2"
                                                         [ngModelOptions]="{standalone: true}"
                                                         [(ngModel)]="tier.stripeDomesticFeePercentage"></fui-numeric-control>
                                </fui-column>
                                <fui-column>
                                    <fui-numeric-control [label]="'fhm.venue-plan.stripeDomesticFeeFixed'"
                                                         [placeholder]="'default'"
                                                         [disabled]="!editing && !model.newVenue"
                                                         [decimals]="2"
                                                         [ngModelOptions]="{standalone: true}"
                                                         [(ngModel)]="tier.stripeDomesticFeeFixed"></fui-numeric-control>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                        <fui-row>
                            <fui-two-columns>
                                <fui-column>
                                    <fui-numeric-control [label]="'fhm.venue-plan.stripeInternationalFeePercentage'"
                                                         [placeholder]="'default'"
                                                         [disabled]="!editing && !model.newVenue"
                                                         [decimals]="2"
                                                         [ngModelOptions]="{standalone: true}"
                                                         [(ngModel)]="tier.stripeInternationalFeePercentage"></fui-numeric-control>
                                </fui-column>
                                <fui-column>
                                    <fui-numeric-control [label]="'fhm.venue-plan.stripeInternationalFeeFixed'"
                                                         [placeholder]="'default'"
                                                         [disabled]="!editing && !model.newVenue"
                                                         [decimals]="2"
                                                         [ngModelOptions]="{standalone: true}"
                                                         [(ngModel)]="tier.stripeInternationalFeeFixed"></fui-numeric-control>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                    </fui-rows>
                </fui-row>
            }
            @if (editing || model.newVenue) {
                <fui-row>
                    <fui-column>
                        <fhm-action-buttons>
                            <fui-link-button [title]="'+ add tier'" (click)="addTier()"></fui-link-button>
                            @if (data.pricingTiers.length > 0) {
                                <fui-link-button [title]="'- remove tier'" (click)="removeTier()"></fui-link-button>
                            }
                        </fhm-action-buttons>
                    </fui-column>
                </fui-row>
            }
        }
        @if (editing && !model.draft) {
            <fui-row>
                <fhm-action-buttons>
                    @if (data) {
                        <fhm-remove-button [title]="'fhm.common.button.cancel'"
                                           (clicked)="cancelEdit()"></fhm-remove-button>
                    }
                    <fhm-provision-button
                        [title]="data ? 'fhm.common.button.save' : 'fhm.common.button.create'"
                        (clicked)="save()"></fhm-provision-button>
                </fhm-action-buttons>
            </fui-row>
        }
    }
</fui-rows>


